const moduleName = 'feedback';

module.exports = () => {

    Array.from(document.querySelectorAll('.js-feedback')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const form = self;
        const button = form.querySelector('.js-feedback-button');
        const buttonText = form.querySelector('.js-feedback-button-text');
        const loadingButtonText = button.getAttribute('data-loading-text');
        const parsleyForm = $(form).parsley();

        parsleyForm.on('form:error', () => {
            dataLayer.push({ 'event': 'request_quote_form_error' });
        });

        form.addEventListener('submit', (event) => {
            event.preventDefault();

            const $fileInputs = $(form).find('input[type="file"]:not([disabled])');

            $fileInputs.each(function(_, input) {
                if (input.files.length > 0) return;
                $(input).prop('disabled', true);
            });

            const xhr = new XMLHttpRequest();
            const formData = new FormData(form);
            const url = form.getAttribute('action');

            button.classList.add('_loading');
            buttonText.innerHTML = loadingButtonText;

            xhr.open('POST', url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    form.classList.add('_success');
                    $fileInputs.prop('disabled', false);
                    dataLayer.push({ 'event': 'form_success' });
                }
            };
            xhr.send(formData);
        });
    });

};